export const MANAGE_TRANSLATIONS_PERMISSION = 'canManageTranslations'

export const TRANSLATIONS_BASE_PATH = '/admin/translations'

export const EDITABLE_LANGUAGE = 'es'
export const SOURCE_LANGUAGE = 'en'

export const PER_PAGE = 50

export const NAMESPACES = [
  'backend',
  'mv-mobile',
  'dnp-mobile',
  'web-marketplace',
]

export const STATUS_LABELS = {
  untranslated: 'Untranslated',
  needs_review: 'Needs review',
  machine: 'Machine',
  approved: 'Approved',
}

export const DEFAULT_STATUS_VIEW = 'review'

/**
 * Status presets shown as tabs. `statuses: null` means no status filter.
 */
export const STATUS_VIEWS = [
  {
    key: 'review',
    label: 'Review queue',
    statuses: ['needs_review', 'untranslated'],
  },
  { key: 'untranslated', label: 'Untranslated', statuses: ['untranslated'] },
  { key: 'needs_review', label: 'Needs review', statuses: ['needs_review'] },
  { key: 'machine', label: 'Machine', statuses: ['machine'] },
  { key: 'approved', label: 'Approved', statuses: ['approved'] },
  { key: 'all', label: 'All', statuses: null },
]

export const APPROVED_STATUS = 'approved'
